import React, {useEffect, useState} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {getContestWinnersData} from "../../store/cabinet/action";
import {formatNumber} from "../cabinetShell/config";

import winnersBg from '../../theme/assets/redesign/contests/winners_bg.webp';
import chevronDown from '../../theme/assets/redesign/contests/chevron_down.svg';
import avatarPlaceholder from '../../theme/assets/redesign/leaderboard/avatar_placeholder.webp';
import crownGold from '../../theme/assets/redesign/leaderboard/crown_gold.svg';
import crownSilver from '../../theme/assets/redesign/leaderboard/crown_silver.svg';
import crownBronze from '../../theme/assets/redesign/leaderboard/crown_bronze.svg';

const CROWNS = {1: crownGold, 2: crownSilver, 3: crownBronze};


// Победители розыгрыша (TOP 20) с выбором круга — макеты 2427:4423 / 2427:4202 / 2467:5352 / 2464:8832
const CabinetContestWinners = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const laps = useSelector(store => store.cabinet.contestWinners);
    const winners = useSelector(store => store.cabinet.contestWinnersData);
    const userData = useSelector(store => store.cabinet.userData);

    const [activeLap, setActiveLap] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (Array.isArray(laps) && laps.length > 0) setActiveLap(laps[0].order);
    }, [laps]);

    const lapsHandler = (order) => {
        dispatch(getContestWinnersData(order));
        setActiveLap(order);
        setOpen(false);
    };

    const list = Array.isArray(winners) ? winners : [];
    const hasData = list.length > 0;
    const me = userData?.user?.username;

    return (
        <section className={`${Styles.container} ${hasData ? '' : Styles.containerEmpty}`}>
            <div className={Styles.bg}>
                <img src={winnersBg} alt=""/>
            </div>

            <div className={Styles.titleRow}>
                <div className={Styles.title}>{t('Победители')} <span>(TOP 20)</span></div>
                {Array.isArray(laps) && laps.length > 0 ? (
                    <div className={Styles.select}>
                        <button type="button" className={Styles.selectBtn} onClick={() => setOpen(o => !o)}>
                            <span>{t('Круг')} #{activeLap || ''}</span>
                            <img className={open ? Styles.chevronOpen : ''} src={chevronDown} alt="" width="16" height="16"/>
                        </button>
                        {open ? (
                            <>
                                <div className={Styles.selectOverlay} onClick={() => setOpen(false)}/>
                                <div className={Styles.selectList}>
                                    {laps.map(item => (
                                        <button
                                            type="button"
                                            key={`lap-${item.order}`}
                                            className={`${Styles.selectItem} ${activeLap === item.order ? Styles.selectItemActive : ''}`}
                                            onClick={() => lapsHandler(item.order)}
                                        >
                                            {t('Круг')} #{item.order}
                                        </button>
                                    ))}
                                </div>
                            </>
                        ) : null}
                    </div>
                ) : null}
            </div>

            {hasData ? (
                <>
                    <div className={Styles.header}>
                        <div className={Styles.colPosition}>#</div>
                        <div className={`${Styles.colAvatar} ${Styles.desktopOnly}`}/>
                        <div className={Styles.colNickname}>{t('Никнейм')}</div>
                        <div className={Styles.colAmount}>{t('Сумма выигрыша')}</div>
                    </div>
                    <div className={Styles.rows}>
                        {list.map((item, index) => {
                            const position = index + 1;
                            const crown = CROWNS[position];
                            const isMe = !!me && item?.username === me;
                            return (
                                <div className={`${Styles.row} ${isMe ? Styles.rowMe : ''}`} key={`winner-${item?.id ?? index}`}>
                                    <div className={`${Styles.colPosition} ${crown ? '' : Styles.noCrown}`}>
                                        {crown ? <img className={Styles.crown} src={crown} alt=""/> : null}
                                        <span>{position}</span>
                                    </div>
                                    <div className={Styles.colAvatar}>
                                        <img src={item?.avatar || avatarPlaceholder} alt=""/>
                                    </div>
                                    <div className={Styles.colNickname}><span>@{item?.username}</span></div>
                                    <div className={Styles.colAmount}>${formatNumber(item?.tokens)}</div>
                                </div>
                            );
                        })}
                    </div>
                </>
            ) : (
                <div className={Styles.empty}>{t('На данный момент, еще нет доступных данных')}.</div>
            )}
        </section>
    );
};

export default CabinetContestWinners;
